import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle/LandingsTitle'
import PortableBlocks from 'components/blocks/PortableBlocks'
import {Col, Container, Row} from 'components/elements/grid'
import {IMake1099Content} from 'pages/make-your-1099'

import s from './Make1099What.module.scss'
const cx = cn.bind(s)

interface IMake1099WhatProps {
	className?: string
	content: IMake1099Content['what']
}

/** Make1099What block component */
const Make1099What: FC<IMake1099WhatProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<Row>
					<Col xl={{span: 10, offset: 1}}>
						<LandingsTitle
							className={s.title}
							title={content?.title}
							subtitle={content?.description}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={{span: 10, offset: 1}} xl={{span: 8, offset: 2}}>
						<div className={s.blocks}>
							{content?.items?.leftList && (
								<PortableBlocks blockContent={content?.items?.leftList} />
							)}
							{content?.items?.rightList && (
								<PortableBlocks blockContent={content?.items?.rightList} />
							)}
						</div>
					</Col>
				</Row>
				<p className={cx('post-description', 'ta-center')}>{content?.postdescription}</p>
			</Container>
		</div>
	)
}

Make1099What.displayName = 'Make1099What'

export default Make1099What
